import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

const Pagination = ({
  currentPage,
  totalPages,
  hasNext,
  hasPrev,
  onPageChange,
}) => {
  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];

    // Show all pages if there are 5 or fewer
    if (totalPages <= 5) {
      for (let i = 0; i < totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    // First pages
    if (currentPage <= 2) {
      pages.push(0, 1, 2, 3, 4);
      pages.push("ellipsis-end");
      pages.push(totalPages - 1);

      return pages;
    }

    // Last pages
    if (currentPage >= totalPages - 3) {
      pages.push(0);
      pages.push("ellipsis-start");
      pages.push(
        totalPages - 5,
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1
      );

      return pages;
    }

    // Middle pages
    pages.push(0);
    pages.push("ellipsis-start");
    pages.push(currentPage - 1);
    pages.push(currentPage);
    pages.push(currentPage + 1);
    pages.push("ellipsis-end");
    pages.push(totalPages - 1);

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <ul className="pagination d-flex flex-wrap align-items-center gap-2 max-sm:gap-1 justify-content-center">
      {/* Previous */}
      <li className="page-item">
        <button
          type="button"
          className={`page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px max-sm:h-24-px text-md ${
            !hasPrev ? "opacity-50 cursor-not-allowed" : ""
          }`}
          onClick={() => hasPrev && onPageChange(currentPage - 1)}
          disabled={!hasPrev}
        >
          <Icon icon="ep:d-arrow-left" />
        </button>
      </li>

      {/* Page Numbers */}
      {pageNumbers.map((page, index) => {
        if (typeof page === "string") {
          return (
            <li className="page-item" key={`${page}-${index}`}>
              <span className="page-link bg-transparent border-0 text-secondary-light fw-semibold d-flex align-items-center justify-content-center h-32-px max-sm:h-24-px text-md">
                ...
              </span>
            </li>
          );
        }

        return (
          <li className="page-item" key={page}>
            <button
              type="button"
              className={`page-link fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px max-sm:h-24-px max-sm:w-24-px text-md ${
                currentPage === page
                  ? "bg-primary-600 text-white"
                  : "bg-neutral-200 text-secondary-light"
              }`}
              onClick={() => onPageChange(page)}
            >
              {page + 1}
            </button>
          </li>
        );
      })}

      {/* Next */}
      <li className="page-item">
        <button
          type="button"
          className={`page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px max-sm:h-24-px text-md ${
            !hasNext ? "opacity-50 cursor-not-allowed" : ""
          }`}
          onClick={() => hasNext && onPageChange(currentPage + 1)}
          disabled={!hasNext}
        >
          <Icon icon="ep:d-arrow-right" />
        </button>
      </li>
    </ul>
  );
};

export default Pagination;